import {
  Box,
  BoxProps,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { AppointmentProductList } from './components/AppointmentProductList';

export const AppointmentDetailsTabs = (props: BoxProps): JSX.Element => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        onChange={handleTabChanges}
        variant="enclosed-colored"
        isLazy
      >
        <TabList>
          <Tab>Produtos</Tab>
        </TabList>

        <TabPanels mt="4">
          <TabPanel>
            <AppointmentProductList />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
